global.webistePlanPriceList = global.API_ADMIN_URL+'webistePlanPriceList/';
global.adminAddWebistePlanPrice = global.API_ADMIN_URL+'adminAddWebistePlanPrice/';
global.adminEditWebistePlanPrice = global.API_ADMIN_URL+'adminEditWebistePlanPrice/';
global.webistePlanPriceDetails = global.API_ADMIN_URL+'webistePlanPriceDetails/';